
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'specialist' | 'caregiver' | Array<'specialist' | 'caregiver'>;
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const location = useLocation();
  const { user, loading, initialized, role } = useAuth();

  // Show loading state while checking auth
  if (loading || !initialized) {
    return (
      <div className="h-screen w-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // If not authenticated, redirect to login while preserving the attempted URL
  if (!user) {
    const signInPath = requiredRole === 'specialist' || (Array.isArray(requiredRole) && requiredRole.includes('specialist') && !requiredRole.includes('caregiver'))
      ? '/coach-signin' 
      : '/signin';
    return <Navigate to={signInPath} state={{ from: location }} replace />;
  }

  if (requiredRole && role) {
    const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!allowedRoles.includes(role as 'specialist' | 'caregiver')) {
      const redirectTo = role === 'specialist' ? '/coach-dashboard' : '/dashboard';
      return <Navigate to={redirectTo} replace />;
    }
  }

  // If authenticated, render children
  return <>{children}</>;
}
